.input {
  background-color: $input-color;
  border-radius: 15px;
  background-image: none !important;
}

::placeholder {
  font-size: 14px;
}
